/*************************************************/
/* HEADER                                        */
/*************************************************/

export function menu() {
  const parentMenuItemSelector = '.menu-nav__item--parent';
  const submenuSelector = '.menu-nav--lvl-2';
  const headerSelector = '.header';
  const solidHeader = "header-solid";
  const parentMenuEnterEvents = ['click'];
  const activeClass = "menu-nav__mega--active";
  const overlayDiv = document.createElement('div');
  overlayDiv.className = 'overlay';

  const closeMenu = () => {
    const openMenus = document.querySelectorAll("." + activeClass);
    openMenus.forEach(menu => {
      menu.setAttribute('aria-hidden', true);
      document.querySelector(headerSelector).classList.remove(solidHeader);
      menu.classList.remove(activeClass);
      menu.previousElementSibling.classList.remove('menu-nav__link--parent--active');
      menu.style.transition = 'transform 0.2s ease';
      document.querySelector(headerSelector).classList.remove(solidHeader);
      if (overlayDiv) {
        overlayDiv.remove();
      }
    });
  };

  const handleMenuItemClick = (e) => {
    e.stopPropagation();
    const submenu = e.currentTarget.querySelector(submenuSelector);
    const isSubMenuOpen = submenu.classList.contains(activeClass);
    closeMenu();

    if (!isSubMenuOpen) {
      submenu.setAttribute('aria-hidden', false);
      if (document.querySelector(".header-transparent")) {
        document.querySelector(headerSelector).classList.add(solidHeader);
      }
      submenu.classList.add(activeClass);
      submenu.previousElementSibling.classList.add('menu-nav__link--parent--active');
      submenu.style.transition = 'transform 0.2s ease';
      document.body.insertAdjacentElement('afterbegin', overlayDiv);
    }
  };

  const init = () => {
    const parentMenuItems = document.querySelectorAll(parentMenuItemSelector);
    if (parentMenuItems.length > 0) {
      parentMenuItems.forEach(item => {
        parentMenuEnterEvents.forEach(event => {
          item.addEventListener(event, handleMenuItemClick);
        });

        // Close menu on body click
        document.body.addEventListener('click', e => {
          const target = e.target;
          const isMenuItem = target.matches(parentMenuItemSelector) || target.closest(parentMenuItemSelector);
          const isSubmenu = target.closest(submenuSelector);
          if (!isMenuItem && !isSubmenu) {
            closeMenu();
          }
        });
      });
    }
  };

  init();
}